class Page {

}

export default Page;